import React from 'react'

import { Customizations } from 'models'

import VehicleSheetLinesGroup from '../VehicleSheetLinesGroup'

const VehicleSheetSectionInternalAdmin = () => {
  const identityItems: (keyof Customizations)[] = [
    'no',
    'entityId',
    'referenceVendeur',
    'licensePlate',
    'vin',
    'locationLocationName',
  ]

  return (
    <VehicleSheetLinesGroup
      arrayOfKeys={identityItems}
      className="vehicle-sheet__identity-items"
    />
  )
}

export default VehicleSheetSectionInternalAdmin
